import { getDomainAndPort } from 'api/Utils';
import { IGuide } from './SiteGuideSlice';

export const initialList: IGuide[] = [
  {
    key: 'login',
    title: 'ورود به سامانه و تعیین رمز',
    link: 'https://app.rastech.ir/content/2/direct/213264',
    group: ['سایر'],
    domain: ['hospitech'],
  },
  {
    key: 'فعالسازی دریافت اعلان ها',
    title: 'فعالسازی دریافت اعلان ها',
    link: 'https://app.rastech.ir/content/2/direct/256878',
    group: ['کلیات سامانه'],
    domain: ['webda'],
  },
  {
    key: 'ورود به سامانه و تعیین رمز',
    title: 'ورود به سامانه و تعیین رمز',
    link: 'https://app.rastech.ir/content/2/direct/213264',
    group: ['کلیات سامانه'],
    domain: ['webda'],
  },
  {
    key: 'manageDocuments',
    title: 'مدیریت اسناد',
    link: 'https://app.rastech.ir/content/2/direct/213261',
    group: ['اسناد'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'documentPermissions',
    title: 'مدیریت دسترسی‌ در اسناد',
    link: 'https://app.rastech.ir/content/2/direct/262351',
    group: ['چک‌لیست', 'اسناد', 'شاخص'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'search-content',
    title: 'جستجو در سامانه و وظایف',
    link: 'https://app.rastech.ir/content/2/direct/213265',
    group: ['اسناد', 'کمیته', 'برنامه عملیاتی'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'fill-checklist',
    title: 'تکمیل چک‌لیست',
    link: 'https://app.rastech.ir/content/2/direct/213267',
    group: ['چک‌لیست'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'checklist-report',
    title: 'مشاهده گزارش‌های چک‌لیست',
    link: 'https://app.rastech.ir/content/2/direct/213268',
    group: ['چک‌لیست'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'indicator-fill',
    title: 'تکمیل شاخص',
    link: 'https://app.rastech.ir/content/2/direct/213270',
    group: ['شاخص'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'indicator-report',
    title: 'مشاهده گزارش‌های شاخص',
    link: 'https://app.rastech.ir/content/2/direct/213271',
    group: ['شاخص'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'indicator-analyse',
    title: 'تحلیل شاخص',
    link: 'https://app.rastech.ir/content/2/direct/213272',
    group: ['شاخص'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'ساخت تک شاخص',
    title: 'ساخت تک شاخص',
    link: 'https://app.rastech.ir/content/2/direct/295114',
    group: ['شاخص'],
    domain: ['webda'],
  },
  {
    key: 'ساخت دستور جلسه',
    title: '۱.آموزش ساخت دستور جلسه',
    link: 'https://app.rastech.ir/content/2/direct/213324',
    group: ['کمیته'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'تایید دستور جلسه',
    title: '۲.تایید دستور جلسه',
    link: 'https://app.rastech.ir/content/2/direct/213092',
    group: ['کمیته'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'آموزش ارسال دستور جلسه',
    title: '۳.آموزش ارسال دستور جلسه',
    link: 'https://app.rastech.ir/content/2/direct/213093',
    group: ['کمیته'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'ثبت حضور و غیاب افراد',
    title: '۴.ثبت حضور و غیاب افراد',
    link: 'https://app.rastech.ir/content/2/direct/213094',
    group: ['کمیته'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'ساخت صورت جلسه',
    title: '۵.ثبت صورتجلسه و مصوبات',
    link: 'https://app.rastech.ir/content/2/direct/213095',
    group: ['کمیته'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'تایید صورتجلسه',
    title: '۶.تایید صورتجلسه',
    link: 'https://app.rastech.ir/content/2/direct/213096',
    group: ['کمیته'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'ارسال جهت امضا',
    title: '۷.ارسال جهت امضا',
    link: 'https://app.rastech.ir/content/2/direct/213097',
    group: ['کمیته'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'امضای صورتجلسه توسط افراد',
    title: '۸.امضای صورتجلسه توسط افراد',
    link: 'https://app.rastech.ir/content/2/direct/213325',
    group: ['کمیته'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'امضای صورتجلسه توسط یک نفر و ضمیمه کردن تصویر امضای گرم',
    title: '9.امضای صورتجلسه توسط یک نفر و ضمیمه کردن تصویر امضای گرم',
    link: 'https://app.rastech.ir/content/2/direct/213326',
    group: ['کمیته'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'ابلاغ نهایی صورتجلسه',
    title: '۱۰.ابلاغ نهایی صورتجلسه',
    link: 'https://app.rastech.ir/content/2/direct/213327',
    group: ['کمیته'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'پرینت صورتجلسه',
    title: '۱۱.پرینت صورتجلسه',
    link: 'https://app.rastech.ir/content/2/direct/213328',
    group: ['کمیته'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'مشاهده مصوبات ابلاغ شده در اکانت شخصی',
    title: '۱۲.مشاهده مصوبات ابلاغ شده در اکانت شخصی',
    link: 'https://app.rastech.ir/content/2/direct/213329',
    group: ['کمیته'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'پایش مصوبات و ثبت پیشرفت',
    title: '۱۳.پایش مصوبات و ثبت پیشرفت',
    link: 'https://app.rastech.ir/content/2/direct/213330',
    group: ['کمیته'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'گزارش‌گیری کمیته',
    title: '۱۴.گزارش‌گیری کمیته',
    link: 'https://app.rastech.ir/content/2/direct/213331',
    group: ['کمیته'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'ساخت برنامه عملیاتی',
    title: '۱.ساخت و ابلاغ برنامه عملیاتی',
    link: 'https://app.rastech.ir/content/2/direct/213332',
    group: ['برنامه عملیاتی'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'مشاهده برنامه هر بخش',
    title: '۲.مشاهده برنامه هر بخش',
    link: 'https://app.rastech.ir/content/2/direct/213333',
    group: ['برنامه عملیاتی'],
    domain: ['hospitech'],
  },
  {
    key: 'مشاهده گام‌های محول شده به هر کس در اکانت خودش',
    title: '۳.مشاهده گام‌های محول شده به هر کس در اکانت خودش',
    link: 'https://app.rastech.ir/content/2/direct/213334',
    group: ['برنامه عملیاتی'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'ثبت پیشرفت برنامه',
    title: '۴.ثبت پیشرفت برنامه',
    link: 'https://app.rastech.ir/content/2/direct/213335',
    group: ['برنامه عملیاتی'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'ضمیمه کردن اسناد به برنامه',
    title: '۵.ضمیمه کردن اسناد به برنامه',
    link: 'https://app.rastech.ir/content/2/direct/213336',
    group: ['برنامه عملیاتی'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'گزارش‌گیری برنامه',
    title: '۶.گزارش‌گیری برنامه',
    link: 'https://app.rastech.ir/content/2/direct/213337',
    group: ['برنامه عملیاتی'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'انتقال کمیته و برنامه',
    title: 'انتقال کمیته و برنامه',
    link: 'https://app.rastech.ir/content/2/direct/213339',
    group: ['برنامه عملیاتی', 'کمیته'],
    domain: ['hospitech'],
  },
  {
    key: 'حذف کمیته و برنامه',
    title: 'حذف کمیته و برنامه',
    link: 'https://app.rastech.ir/content/2/direct/213340',
    group: ['برنامه عملیاتی', 'کمیته'],
    domain: ['hospitech'],
  },
  {
    key: 'ثبت درخواست پشتیبانی',
    title: 'ثبت درخواست پشتیبانی',
    link: 'https://app.rastech.ir/content/2/direct/213972',
    group: ['پشتیبانی'],
    domain: ['hospitech'],
  },
  {
    key: 'پیگیری درخواست پشتیبانی',
    title: 'پیگیری درخواست پشتیبانی',
    link: 'https://app.rastech.ir/content/2/direct/213974',
    group: ['پشتیبانی'],
    domain: ['hospitech'],
  },
  {
    key: 'مدیریت کاربران',
    title: 'مدیریت کاربران',
    link: 'https://app.rastech.ir/content/2/direct/215094',
    group: ['مدیریت سامانه'],
    domain: ['hospitech', 'webda'],
  },
  {
    key: 'مدیریت کاربران در سامانه هاسپیتک',
    title: 'مدیریت کاربران در سامانه هاسپیتک',
    link: 'https://app.rastech.ir/content/2/direct/215094',
    group: ['مدیریت سامانه'],
    domain: ['webda'],
  },
  {
    key: 'مدیریت کاربران در تسک منیجر',
    title: 'مدیریت کاربران در تسک منیجر',
    link: 'https://app.rastech.ir/content/2/direct/215095',
    group: ['مدیریت سامانه'],
    domain: ['webda'],
  },
  {
    key: 'مدیریت کاربران کمیته‌ها/برنامه‌ها',
    title: 'مدیریت کاربران کمیته‌ها/برنامه‌ها',
    link: 'https://app.rastech.ir/content/2/direct/215095',
    group: ['مدیریت سامانه'],
    domain: ['hospitech'],
  },
  {
    key: 'ثبت نیازسنجی آموزشی',
    title: 'ثبت نیازسنجی آموزشی',
    link: 'https://app.rastech.ir/content/2/direct/278518',
    group: ['آموزش کارکنان'],
    domain: ['hospitech'],
  },
  {
    key: 'مشاهده کارنامه',
    title: 'مشاهده کارنامه',
    link: 'https://app.rastech.ir/content/2/direct/295324',
    group: ['آموزش کارکنان'],
    domain: ['hospitech'],
  },
  {
    key: 'تایید /رد نیازسنجی',
    title: 'تایید /رد نیازسنجی',
    link: 'https://app.rastech.ir/content/2/direct/295340',
    group: ['آموزش کارکنان'],
    domain: ['hospitech'],
  },
  {
    key: 'ساخت دوره آموزشی',
    title: 'ساخت دوره آموزشی',
    link: 'https://app.rastech.ir/content/2/direct/295590',
    group: ['آموزش کارکنان'],
    domain: ['hospitech'],
  },
  {
    key: 'ساخت آزمون در دوره (پیش آزمون/پس آزمون)',
    title: 'ساخت آزمون در دوره (پیش آزمون/پس آزمون)',
    link: 'https://app.rastech.ir/content/2/direct/295392',
    group: ['آموزش کارکنان'],
    domain: ['hospitech'],
  },
  {
    key: 'نمونه فرمت سوالات اکسل برای ساخت آزمون',
    title: 'نمونه فرمت سوالات اکسل برای ساخت آزمون',
    link: 'https://app.rastech.ir/content/2/direct/295566',
    group: ['آموزش کارکنان'],
    domain: ['hospitech'],
  },
  {
    key: 'تنظیم پیامک/یادآور در دوره',
    title: 'تنظیم پیامک/یادآور در دوره',
    link: 'https://app.rastech.ir/content/2/direct/295399',
    group: ['آموزش کارکنان'],
    domain: ['hospitech'],
  },
  {
    key: 'نحوه ی شرکت در آزمون',
    title: 'نحوه ی شرکت در آزمون',
    link: 'https://app.rastech.ir/content/2/direct/295419',
    group: ['آموزش کارکنان'],
    domain: ['hospitech'],
  },
];
export const guides: () => Array<IGuide> = () => {
  const watchedList = localStorage.getItem('watchedGuides');
  const tutorialDomains = getDomainAndPort().domainFeatures
    ?.tutorialsDomain ?? ['hospitech'];

  const tutorialDomainSet = new Set(tutorialDomains);

  const domainInitialList = initialList.filter((el) =>
    el?.domain?.some((d) => tutorialDomainSet.has(d))
  );

  if (watchedList) {
    let watchedGuideKeys = JSON.parse(watchedList) || [];
    if (!Array.isArray(watchedList)) watchedGuideKeys = [];
    return domainInitialList.map((itm) => {
      if (watchedGuideKeys.includes(itm.key)) {
        return {
          ...itm,
          isWatched: true,
        };
      } else return itm;
    });
  } else {
    return domainInitialList;
  }
};
